import React from 'react';
import { JsonPropsType } from '../../component-loader';
import { V2Product } from './types';

interface PlaygroundV2AppProps {
  products: V2Product[];
}

export function PlaygroundV2App(props: JsonPropsType) {
  const { products } = props.jsonObject as PlaygroundV2AppProps;

  return (
    <div className="playground-v2-app">
      <div className="row g-3">
        {products.map((product) => (
          <div key={product.slug} className="col-md-6 col-lg-4">
            <div className="card h-100">
              <div className="card-body d-flex flex-column">
                <h5 className="card-title">{product.name}</h5>
                <code className="d-block mb-3 text-secondary small">
                  POST
                  {' '}
                  {product.path}
                </code>
                <a
                  href={`/v2/playground/${product.slug}/`}
                  className="btn btn-primary btn-sm mt-auto align-self-start"
                >
                  Probar
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
